/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AddNewClauseLanguage } from '@coin/shared/core/util-models-v2';
import { ApproveClauseVersion } from '@coin/shared/core/util-models-v2';
import { ApproveTemplateVersion } from '@coin/shared/core/util-models-v2';
import { AttributeAssignments } from '@coin/shared/core/util-models-v2';
import { BaseRedisEntity } from '@coin/shared/core/util-models-v2';
import { ChangeSignersForAssignment } from '@coin/shared/core/util-models-v2';
import { ChangeStatusForAssignments } from '@coin/shared/core/util-models-v2';
import { CheckPermissionsForDownload } from '@coin/shared/core/util-models-v2';
import { ClauseDetails } from '@coin/shared/core/util-models-v2';
import { ClauseFieldValueWithCounts } from '@coin/shared/core/util-models-v2';
import { ClauseVersion } from '@coin/shared/core/util-models-v2';
import { ConclusiveTransactionStatusOfTemplateSimulationMetadata } from '@coin/shared/core/util-models-v2';
import { ContractActionDetails } from '@coin/shared/core/util-models-v2';
import { ContractAssignmentLight } from '@coin/shared/core/util-models-v2';
import { CreateClause } from '@coin/shared/core/util-models-v2';
import { CreateClauseVersionDraft } from '@coin/shared/core/util-models-v2';
import { CreateTemplateDraftVersion } from '@coin/shared/core/util-models-v2';
import { CreateTemplateExport } from '@coin/shared/core/util-models-v2';
import { CreateTemplateVersionAttachment } from '@coin/shared/core/util-models-v2';
import { DocumentGenerationFieldValueWithCounts } from '@coin/shared/core/util-models-v2';
import { DocumentGenerationValidationRequest } from '@coin/shared/core/util-models-v2';
import { DuplicateClause } from '@coin/shared/core/util-models-v2';
import { DuplicateTemplate } from '@coin/shared/core/util-models-v2';
import { EntitySearchScope } from '@coin/shared/core/util-models-v2';
import { ExportClauseActivities } from '@coin/shared/core/util-models-v2';
import { ExportClauseTemplateAssociations } from '@coin/shared/core/util-models-v2';
import { ExportClauses } from '@coin/shared/core/util-models-v2';
import { ExportContractAssignments } from '@coin/shared/core/util-models-v2';
import { ExportTemplateActivitiesParameter } from '@coin/shared/core/util-models-v2';
import { FieldValues } from '@coin/shared/core/util-models-v2';
import { FilledTemplateContentResponse } from '@coin/shared/core/util-models-v2';
import { GenerateNewDocuments } from '@coin/shared/core/util-models-v2';
import { MatchedTemplate } from '@coin/shared/core/util-models-v2';
import { PageOfActivityStreamOfString } from '@coin/shared/core/util-models-v2';
import { PageOfAttributeLight } from '@coin/shared/core/util-models-v2';
import { PageOfClauseDetailsLight } from '@coin/shared/core/util-models-v2';
import { PageOfContractActionLight } from '@coin/shared/core/util-models-v2';
import { PageOfContractAssignmentLight } from '@coin/shared/core/util-models-v2';
import { PageOfEclEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfEmploymentConditionLibraryUsersUser } from '@coin/shared/core/util-models-v2';
import { PageOfSignerEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PageOfTemplateDetailsLight } from '@coin/shared/core/util-models-v2';
import { PublishDocuments } from '@coin/shared/core/util-models-v2';
import { QuerySimulatedEmployees } from '@coin/shared/core/util-models-v2';
import { RejectClauseVersion } from '@coin/shared/core/util-models-v2';
import { RejectTemplateVersion } from '@coin/shared/core/util-models-v2';
import { RetireClause } from '@coin/shared/core/util-models-v2';
import { RetireTemplate } from '@coin/shared/core/util-models-v2';
import { SendToApprover } from '@coin/shared/core/util-models-v2';
import { SimulateTemplateContent } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';
import { TemplateDetails } from '@coin/shared/core/util-models-v2';
import { TemplateFieldValueWithCounts } from '@coin/shared/core/util-models-v2';
import { TemplateVersion } from '@coin/shared/core/util-models-v2';
import { TemplateVersionAttachment } from '@coin/shared/core/util-models-v2';
import { TemplatesCreateTemplate } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfDocumentGenerationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfRecomputeTemplateAttributesMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSimpleStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransferEmploymentConditionsLibraryEntity } from '@coin/shared/core/util-models-v2';
import { UpdateClauseVersion } from '@coin/shared/core/util-models-v2';
import { UpdateTemplateRuleSet } from '@coin/shared/core/util-models-v2';
import { UpdateTemplateVersion } from '@coin/shared/core/util-models-v2';
import { UpdateTemplateVersionContent } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface AbortClauseVersionsParams {
  clauseId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface AbortTemplateVersionsParams {
  templateId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface AddAttachmentTemplateVersionsParams {
  templateId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  createTemplateVersionAttachment?: CreateTemplateVersionAttachment;
}

export interface AddNewClauseLanguageClausesParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  addNewClauseLanguage?: AddNewClauseLanguage;
}

export interface ApproveClauseVersionsParams {
  clauseId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  approveClauseVersion?: ApproveClauseVersion;
}

export interface ApproveTemplateVersionsParams {
  templateId: string;
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  approveTemplateVersion?: ApproveTemplateVersion;
}

export interface ArchiveContractActionContractActionsParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface ChangeSignersForAssignmentContractAssignmentParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  changeSignersForAssignment?: ChangeSignersForAssignment;
}

export interface ChangeStatusForAssignmentsContractActionsParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  changeStatusForAssignments?: ChangeStatusForAssignments;
}

export interface CheckPermissionsContractAssignmentParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  checkPermissionsForDownload?: CheckPermissionsForDownload;
}

export interface CreateClausesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  createClause?: CreateClause;
}

export interface CreateDraftClauseVersionsParams {
  clauseId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  createClauseVersionDraft?: CreateClauseVersionDraft;
}

export interface CreateDraftTemplateVersionsParams {
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  createTemplateDraftVersion?: CreateTemplateDraftVersion;
}

export interface CreateTemplatesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  templatesCreateTemplate?: TemplatesCreateTemplate;
}

export interface DeleteAttachmentTemplateVersionsParams {
  versionId: string;
  id: string;
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface DeleteClauseLanguagesClausesParams {
  id: string;
  languageCodes: Array<string>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface DeleteClauseVersionsParams {
  versionId: string;
  clauseId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface DeleteTemplateVersionsParams {
  versionId: string;
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface DropContractActionContractActionsParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface DuplicateClauseClausesParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  duplicateClause?: DuplicateClause;
}

export interface DuplicateTemplatesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  duplicateTemplate?: DuplicateTemplate;
}

export interface EmploymentConditionLibraryCustomerGenerateDocumentGenerationParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  generateNewDocuments?: GenerateNewDocuments;
}

export interface EmploymentConditionLibraryCustomerGetScopeAttributesParams {
  name?: string;
  country?: string;
  legalEntity?: string;
  isGlobal?: boolean;
  searchQuery?: string;
  discriminator?: Array<string>;
  isAttributeUpload?: boolean;
  hasValuesAssigned?: boolean;
  includeValues?: boolean;
  variableType?: 'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage';
  templateVersionId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  effectiveDate?: string;
}

export interface EmploymentConditionLibraryCustomerGetValuesByIdAttributesParams {
  id: string;
  pageablePage?: number;
  pageableSize?: number;
  name?: string;
  country?: string;
  legalEntity?: string;
  isGlobal?: boolean;
  searchQuery?: string;
  discriminator?: Array<string>;
  isAttributeUpload?: boolean;
  hasValuesAssigned?: boolean;
  includeValues?: boolean;
  variableType?: 'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage';
  templateVersionId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  effectiveDate?: string;
}

export interface EmploymentConditionLibraryCustomerQueryAttributesParams {
  queryName?: string;
  queryCountry?: string;
  queryLegalEntity?: string;
  queryIsGlobal?: boolean;
  querySearchQuery?: string;
  queryDiscriminator?: Array<string>;
  queryIsAttributeUpload?: boolean;
  queryHasValuesAssigned?: boolean;
  queryIncludeValues?: boolean;
  queryVariableType?: 'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage';
  queryTemplateVersionId?: string;
  queryModule?: 'Default' | 'Restructuring' | 'Playground';
  queryEffectiveDate?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerQueryByGidsEmployeesParams {
  country: string;
  legalEntity: string;
  gids?: Array<string>;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerQueryClauseCategoriesParams {
  type: string;
  searchQuery?: string;
  cluster?: string;
  subject?: string;
  topic?: string;
  queryCountries?: Array<string>;
  queryLegalEntities?: Array<string>;
  queryClusters?: Array<string>;
  querySubjects?: Array<string>;
  queryTopics?: Array<string>;
  queryNames?: Array<string>;
  queryClauseGroups?: Array<string>;
  querySearch?: string;
  queryClauseStatus?: Array<'Draft' | 'Published' | 'Retired' | 'PendingApproval'>;
  queryEffectiveTo?: string;
  queryWithContent?: boolean;
  queryLocalLanguage?: string;
  queryEffectiveFrom?: string;
  queryIsQueryingForTemplate?: boolean;
  queryEffectiveDate?: string;
  categoryQueryClusterValues?: Array<string>;
  categoryQueryClusterType?: string;
  categoryQuerySubjectValues?: Array<string>;
  categoryQuerySubjectType?: string;
  categoryQueryTopicValues?: Array<string>;
  categoryQueryTopicType?: string;
  pageablePage?: number;
  pageableSize?: number;
  parentId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerQueryEmployeesParams {
  searchString?: string;
  includeManagerInformation?: boolean;
  queryGid?: string;
  queryFullName?: string;
  queryCountry?: Array<string>;
  queryLegalEntity?: Array<string>;
  queryDataSource?: Array<string>;
  queryModule?: 'Default' | 'Restructuring' | 'Playground';
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  effectiveDate?: string;
}

export interface EmploymentConditionLibraryCustomerQueryFieldValueEmployeesParams {
  fieldName: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4;
  gid?: string;
  fullName?: string;
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSource?: Array<string>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerQueryFieldValuesAttributesParams {
  fieldName: string;
  name?: string;
  country?: string;
  legalEntity?: string;
  isGlobal?: boolean;
  searchQuery?: string;
  discriminator?: Array<string>;
  isAttributeUpload?: boolean;
  hasValuesAssigned?: boolean;
  includeValues?: boolean;
  variableType?: 'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage';
  templateVersionId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  effectiveDate?: string;
  page?: number;
  size?: number;
}

export interface EmploymentConditionLibraryCustomerQuerySimulatedEmployeesEmployeesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  querySimulatedEmployees?: QuerySimulatedEmployees;
}

export interface EmploymentConditionLibraryCustomerQueryUsersParams {
  searchString?: string;
  firstname?: Array<string>;
  lastname?: Array<string>;
  middlename?: Array<string>;
  gid?: Array<string>;
  isApproverAuthorized?: boolean;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface ExportClausesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  exportClauses?: ExportClauses;
}

export interface ExportContractAssignmentParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  exportContractAssignments?: ExportContractAssignments;
}

export interface ExportFilteredActivityStreamClauseActivityStreamParams {
  exportClauseActivities?: ExportClauseActivities;
}

export interface ExportFilteredActivityStreamTemplateActivityStreamParams {
  exportTemplateActivitiesParameter?: ExportTemplateActivitiesParameter;
}

export interface ExportTemplateAssociationsClausesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  exportClauseTemplateAssociations?: ExportClauseTemplateAssociations;
}

export interface ExportTemplatesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  createTemplateExport?: CreateTemplateExport;
}

export interface GenerateContractActionContentDocumentGenerationParams {
  actionId: string;
  employeeId: string;
}

export interface GetActivityStreamForVersionClauseVersionsParams {
  clauseId: string;
  versionId: string;
  page?: number;
  size?: number;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetAttributesTemplateVersionSimulationParams {
  versionId: string;
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetCachedContentDocumentGenerationParams {
  actionId: string;
  employeeId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetClauseDetailsClausesParams {
  clauseId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetClauseVersionClauseVersionsParams {
  clauseId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetContractActionsParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetCountryAndAreCountsContractActionsParams {
  countries?: Array<string>;
  legalEntities?: Array<string>;
  contractActionStatus?: Array<'Active' | 'Archived'>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetLatestClauseVersionsParams {
  clauseId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetLatestTemplateVersionsParams {
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetSimulatedContentTemplateVersionSimulationParams {
  versionId: string;
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetTemplateVersionsParams {
  templateId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetTemplatesParams {
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface PublishDocumentsContractActionsParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  publishDocuments?: PublishDocuments;
}

export interface QueryActivityStreamTemplateVersionsParams {
  templateId: string;
  versionId: string;
  page?: number;
  size?: number;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryByTemplateEmployeesParams {
  templateId: string;
  effectiveDate?: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryClausesParams {
  countries?: Array<string>;
  legalEntities?: Array<string>;
  clusters?: Array<string>;
  subjects?: Array<string>;
  topics?: Array<string>;
  names?: Array<string>;
  clauseGroups?: Array<string>;
  search?: string;
  clauseStatus?: Array<'Draft' | 'Published' | 'Retired' | 'PendingApproval'>;
  effectiveTo?: string;
  withContent?: boolean;
  localLanguage?: string;
  effectiveFrom?: string;
  isQueryingForTemplate?: boolean;
  effectiveDate?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryContractActionsParams {
  queryLegalEntities?: Array<string>;
  queryCountries?: Array<string>;
  queryDocumentType?: Array<'EmploymentContract' | 'Policy' | 'Addendum' | 'Contract'>;
  querySearch?: string;
  queryContractActionStatus?: Array<'Active' | 'Archived'>;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryContractAssignmentsContractActionsParams {
  id: string;
  queryStatus?: Array<'Draft' | 'Published' | 'Signed' | 'Dropped' | 'Failed' | 'Creating'>;
  querySearchQuery?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryFieldValueWithCountsClausesParams {
  queryTargetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  queryCountries?: Array<string>;
  queryLegalEntities?: Array<string>;
  queryClusters?: Array<string>;
  querySubjects?: Array<string>;
  queryTopics?: Array<string>;
  queryNames?: Array<string>;
  queryClauseGroups?: Array<string>;
  querySearch?: string;
  queryClauseStatus?: Array<'Draft' | 'Published' | 'Retired' | 'PendingApproval'>;
  queryEffectiveTo?: string;
  queryWithContent?: boolean;
  queryLocalLanguage?: string;
  queryEffectiveFrom?: string;
  queryIsQueryingForTemplate?: boolean;
  queryEffectiveDate?: string;
  country?: Array<string>;
  legalEntity?: Array<string>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryFieldValuesContractActionsParams {
  pageableRequestPage?: number;
  pageableRequestSize?: number;
  targetProperty?: 0 | 1 | 2;
  legalEntities?: Array<string>;
  countries?: Array<string>;
  documentType?: Array<'EmploymentContract' | 'Policy' | 'Addendum' | 'Contract'>;
  search?: string;
  contractActionStatus?: Array<'Active' | 'Archived'>;
}

export interface QueryFieldValuesForClauseCreationClausesParams {
  queryTargetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  queryCountries?: Array<string>;
  queryLegalEntities?: Array<string>;
  queryClusters?: Array<string>;
  querySubjects?: Array<string>;
  queryTopics?: Array<string>;
  queryNames?: Array<string>;
  queryClauseGroups?: Array<string>;
  querySearch?: string;
  queryClauseStatus?: Array<'Draft' | 'Published' | 'Retired' | 'PendingApproval'>;
  queryEffectiveTo?: string;
  queryWithContent?: boolean;
  queryLocalLanguage?: string;
  queryEffectiveFrom?: string;
  queryIsQueryingForTemplate?: boolean;
  queryEffectiveDate?: string;
  pageablePage?: number;
  pageableSize?: number;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryFieldValuesTemplatesParams {
  countries?: Array<string>;
  legalEntities?: Array<string>;
  isQueryingForDocumentGeneration?: boolean;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryFilteredActivityStreamClauseActivityStreamParams {
  page?: number;
  size?: number;
  name?: string;
  userSearch?: string;
  eventOperation?: 'Created' | 'Updated' | 'Deleted';
  fromDate?: string;
  toDate?: string;
  changedProperty?: string;
  metadataItem?: string;
  country?: string;
  are?: string;
  eventTypes?: Array<string>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryFilteredActivityStreamTemplateActivityStreamParams {
  page?: number;
  size?: number;
  name?: string;
  userSearch?: string;
  eventOperation?: 'Created' | 'Updated' | 'Deleted';
  fromDate?: string;
  toDate?: string;
  changedProperty?: string;
  metadataItem?: string;
  country?: string;
  are?: string;
  eventTypes?: Array<string>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QuerySignatureAuthorizationParams {
  legalEntity: string;
  pageablePage?: number;
  pageableSize?: number;
  searchQuery?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryTemplatesParams {
  queryCountries?: Array<string>;
  queryLegalEntities?: Array<string>;
  queryTemplateType?: Array<'EmploymentContract' | 'Policy' | 'Addendum' | 'Contract'>;
  queryClauseIds?: Array<string>;
  querySearch?: string;
  queryTemplateStatus?: Array<'Draft' | 'PendingApproval' | 'Published' | 'Retired'>;
  queryIsQueryingForDocumentGeneration?: boolean;
  queryApprover?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface RejectClauseVersionsParams {
  clauseId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  rejectClauseVersion?: RejectClauseVersion;
}

export interface RejectTemplateVersionsParams {
  templateId: string;
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  rejectTemplateVersion?: RejectTemplateVersion;
}

export interface RetireClauseClausesParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  retireClause?: RetireClause;
}

export interface RetireTemplatesParams {
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  retireTemplate?: RetireTemplate;
}

export interface SendToApproverClauseVersionsParams {
  clauseId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  sendToApprover?: SendToApprover;
}

export interface SendToApproverTemplateVersionsParams {
  templateId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  sendToApprover?: SendToApprover;
}

export interface SimulateContentTemplateVersionSimulationParams {
  versionId: string;
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  simulateTemplateContent?: SimulateTemplateContent;
}

export interface TransferClauseClausesParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  transferEmploymentConditionsLibraryEntity?: TransferEmploymentConditionsLibraryEntity;
}

export interface TransferTemplateTemplatesParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  transferEmploymentConditionsLibraryEntity?: TransferEmploymentConditionsLibraryEntity;
}

export interface UpdateClauseVersionsParams {
  clauseId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  updateClauseVersion?: UpdateClauseVersion;
}

export interface UpdateContentTemplateVersionsParams {
  templateId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  updateTemplateVersionContent?: UpdateTemplateVersionContent;
}

export interface UpdateTemplateRuleSetTemplatesParams {
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  updateTemplateRuleSet?: UpdateTemplateRuleSet;
}

export interface UpdateTemplateVersionsParams {
  templateId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  updateTemplateVersion?: UpdateTemplateVersion;
}

export interface ValidateDocumentGenerationParams {
  documentGenerationValidationRequest?: DocumentGenerationValidationRequest;
}

@Injectable({
  providedIn: 'root'
})
export class EmploymentConditionLibraryCustomerService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public abortClauseVersions(
    requestParameters?: AbortClauseVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public abortClauseVersions(
    requestParameters?: AbortClauseVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public abortClauseVersions(
    requestParameters?: AbortClauseVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public abortClauseVersions(requestParameters?: AbortClauseVersionsParams, ...args: RequestArgs): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('abortClauseVersions', { clauseId, versionId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/abort`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public abortTemplateVersions(
    requestParameters?: AbortTemplateVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public abortTemplateVersions(
    requestParameters?: AbortTemplateVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public abortTemplateVersions(
    requestParameters?: AbortTemplateVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public abortTemplateVersions(requestParameters?: AbortTemplateVersionsParams, ...args: RequestArgs): Observable<any> {
    const templateId = requestParameters?.templateId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('abortTemplateVersions', { templateId, versionId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/abort`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addAttachmentTemplateVersions(
    requestParameters?: AddAttachmentTemplateVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TemplateVersionAttachment>;
  public addAttachmentTemplateVersions(
    requestParameters?: AddAttachmentTemplateVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TemplateVersionAttachment>>;
  public addAttachmentTemplateVersions(
    requestParameters?: AddAttachmentTemplateVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TemplateVersionAttachment>>;
  public addAttachmentTemplateVersions(
    requestParameters?: AddAttachmentTemplateVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('addAttachmentTemplateVersions', { templateId, versionId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attachments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.createTemplateVersionAttachment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addNewClauseLanguageClauses(
    requestParameters?: AddNewClauseLanguageClausesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClauseDetails>;
  public addNewClauseLanguageClauses(
    requestParameters?: AddNewClauseLanguageClausesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClauseDetails>>;
  public addNewClauseLanguageClauses(
    requestParameters?: AddNewClauseLanguageClausesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClauseDetails>>;
  public addNewClauseLanguageClauses(
    requestParameters?: AddNewClauseLanguageClausesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('addNewClauseLanguageClauses', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/new-language`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.addNewClauseLanguage,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public approveClauseVersions(
    requestParameters?: ApproveClauseVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public approveClauseVersions(
    requestParameters?: ApproveClauseVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public approveClauseVersions(
    requestParameters?: ApproveClauseVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public approveClauseVersions(requestParameters?: ApproveClauseVersionsParams, ...args: RequestArgs): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('approveClauseVersions', { clauseId, versionId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approve`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.approveClauseVersion,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public approveTemplateVersions(
    requestParameters?: ApproveTemplateVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public approveTemplateVersions(
    requestParameters?: ApproveTemplateVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public approveTemplateVersions(
    requestParameters?: ApproveTemplateVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public approveTemplateVersions(
    requestParameters?: ApproveTemplateVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    const id = requestParameters?.id;
    this.checkRequired('approveTemplateVersions', { templateId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approve`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.approveTemplateVersion,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public archiveContractActionContractActions(
    requestParameters?: ArchiveContractActionContractActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ContractActionDetails>;
  public archiveContractActionContractActions(
    requestParameters?: ArchiveContractActionContractActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ContractActionDetails>>;
  public archiveContractActionContractActions(
    requestParameters?: ArchiveContractActionContractActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ContractActionDetails>>;
  public archiveContractActionContractActions(
    requestParameters?: ArchiveContractActionContractActionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('archiveContractActionContractActions', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/folders/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/archive`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changeSignersForAssignmentContractAssignment(
    requestParameters?: ChangeSignersForAssignmentContractAssignmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ContractAssignmentLight>;
  public changeSignersForAssignmentContractAssignment(
    requestParameters?: ChangeSignersForAssignmentContractAssignmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ContractAssignmentLight>>;
  public changeSignersForAssignmentContractAssignment(
    requestParameters?: ChangeSignersForAssignmentContractAssignmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ContractAssignmentLight>>;
  public changeSignersForAssignmentContractAssignment(
    requestParameters?: ChangeSignersForAssignmentContractAssignmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('changeSignersForAssignmentContractAssignment', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/condition-library/customer/v1/contract-assignments/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/signers`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.changeSignersForAssignment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changeStatusForAssignmentsContractActions(
    requestParameters?: ChangeStatusForAssignmentsContractActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public changeStatusForAssignmentsContractActions(
    requestParameters?: ChangeStatusForAssignmentsContractActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public changeStatusForAssignmentsContractActions(
    requestParameters?: ChangeStatusForAssignmentsContractActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public changeStatusForAssignmentsContractActions(
    requestParameters?: ChangeStatusForAssignmentsContractActionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('changeStatusForAssignmentsContractActions', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/condition-library/customer/v1/folders/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/change-status`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.changeStatusForAssignments,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public checkPermissionsContractAssignment(
    requestParameters?: CheckPermissionsContractAssignmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public checkPermissionsContractAssignment(
    requestParameters?: CheckPermissionsContractAssignmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public checkPermissionsContractAssignment(
    requestParameters?: CheckPermissionsContractAssignmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public checkPermissionsContractAssignment(
    requestParameters?: CheckPermissionsContractAssignmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/contract-assignments/check-permissions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.checkPermissionsForDownload,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createClauses(
    requestParameters?: CreateClausesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClauseDetails>;
  public createClauses(
    requestParameters?: CreateClausesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClauseDetails>>;
  public createClauses(
    requestParameters?: CreateClausesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClauseDetails>>;
  public createClauses(requestParameters?: CreateClausesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/clauses`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.createClause,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createDraftClauseVersions(
    requestParameters?: CreateDraftClauseVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClauseVersion>;
  public createDraftClauseVersions(
    requestParameters?: CreateDraftClauseVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClauseVersion>>;
  public createDraftClauseVersions(
    requestParameters?: CreateDraftClauseVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClauseVersion>>;
  public createDraftClauseVersions(
    requestParameters?: CreateDraftClauseVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    this.checkRequired('createDraftClauseVersions', { clauseId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.createClauseVersionDraft,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createDraftTemplateVersions(
    requestParameters?: CreateDraftTemplateVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TemplateVersion>;
  public createDraftTemplateVersions(
    requestParameters?: CreateDraftTemplateVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TemplateVersion>>;
  public createDraftTemplateVersions(
    requestParameters?: CreateDraftTemplateVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TemplateVersion>>;
  public createDraftTemplateVersions(
    requestParameters?: CreateDraftTemplateVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    this.checkRequired('createDraftTemplateVersions', { templateId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.createTemplateDraftVersion,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createTemplates(
    requestParameters?: CreateTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TemplateDetails>;
  public createTemplates(
    requestParameters?: CreateTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TemplateDetails>>;
  public createTemplates(
    requestParameters?: CreateTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TemplateDetails>>;
  public createTemplates(requestParameters?: CreateTemplatesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/templates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.templatesCreateTemplate,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteAttachmentTemplateVersions(
    requestParameters?: DeleteAttachmentTemplateVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteAttachmentTemplateVersions(
    requestParameters?: DeleteAttachmentTemplateVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteAttachmentTemplateVersions(
    requestParameters?: DeleteAttachmentTemplateVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteAttachmentTemplateVersions(
    requestParameters?: DeleteAttachmentTemplateVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const versionId = requestParameters?.versionId;
    const id = requestParameters?.id;
    const templateId = requestParameters?.templateId;
    this.checkRequired('deleteAttachmentTemplateVersions', { versionId, id, templateId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attachments/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: [],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteClauseLanguagesClauses(
    requestParameters?: DeleteClauseLanguagesClausesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClauseDetails>;
  public deleteClauseLanguagesClauses(
    requestParameters?: DeleteClauseLanguagesClausesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClauseDetails>>;
  public deleteClauseLanguagesClauses(
    requestParameters?: DeleteClauseLanguagesClausesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClauseDetails>>;
  public deleteClauseLanguagesClauses(
    requestParameters?: DeleteClauseLanguagesClausesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const languageCodes = requestParameters?.languageCodes;
    this.checkRequired('deleteClauseLanguagesClauses', { id, languageCodes });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/delete-language`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { LanguageCodes: languageCodes, module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteClauseVersions(
    requestParameters?: DeleteClauseVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteClauseVersions(
    requestParameters?: DeleteClauseVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteClauseVersions(
    requestParameters?: DeleteClauseVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteClauseVersions(requestParameters?: DeleteClauseVersionsParams, ...args: RequestArgs): Observable<any> {
    const versionId = requestParameters?.versionId;
    const clauseId = requestParameters?.clauseId;
    this.checkRequired('deleteClauseVersions', { versionId, clauseId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTemplateVersions(
    requestParameters?: DeleteTemplateVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteTemplateVersions(
    requestParameters?: DeleteTemplateVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteTemplateVersions(
    requestParameters?: DeleteTemplateVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteTemplateVersions(
    requestParameters?: DeleteTemplateVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const versionId = requestParameters?.versionId;
    const templateId = requestParameters?.templateId;
    this.checkRequired('deleteTemplateVersions', { versionId, templateId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public dropContractActionContractActions(
    requestParameters?: DropContractActionContractActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ContractActionDetails>;
  public dropContractActionContractActions(
    requestParameters?: DropContractActionContractActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ContractActionDetails>>;
  public dropContractActionContractActions(
    requestParameters?: DropContractActionContractActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ContractActionDetails>>;
  public dropContractActionContractActions(
    requestParameters?: DropContractActionContractActionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('dropContractActionContractActions', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/condition-library/customer/v1/folders/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public duplicateClauseClauses(
    requestParameters?: DuplicateClauseClausesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClauseDetails>;
  public duplicateClauseClauses(
    requestParameters?: DuplicateClauseClausesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClauseDetails>>;
  public duplicateClauseClauses(
    requestParameters?: DuplicateClauseClausesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClauseDetails>>;
  public duplicateClauseClauses(
    requestParameters?: DuplicateClauseClausesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('duplicateClauseClauses', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/duplicate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.duplicateClause,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public duplicateTemplates(
    requestParameters?: DuplicateTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TemplateDetails>;
  public duplicateTemplates(
    requestParameters?: DuplicateTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TemplateDetails>>;
  public duplicateTemplates(
    requestParameters?: DuplicateTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TemplateDetails>>;
  public duplicateTemplates(requestParameters?: DuplicateTemplatesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/templates/duplicate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.duplicateTemplate,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryCustomerGenerateDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerGenerateDocumentGenerationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfDocumentGenerationMetadata>;
  public employmentConditionLibraryCustomerGenerateDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerGenerateDocumentGenerationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfDocumentGenerationMetadata>>;
  public employmentConditionLibraryCustomerGenerateDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerGenerateDocumentGenerationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfDocumentGenerationMetadata>>;
  public employmentConditionLibraryCustomerGenerateDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerGenerateDocumentGenerationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/document-generation`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.generateNewDocuments,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryCustomerGetScopeAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerGetScopeAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EntitySearchScope>;
  public employmentConditionLibraryCustomerGetScopeAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerGetScopeAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EntitySearchScope>>;
  public employmentConditionLibraryCustomerGetScopeAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerGetScopeAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EntitySearchScope>>;
  public employmentConditionLibraryCustomerGetScopeAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerGetScopeAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/attributes/scope`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Name: requestParameters?.name,
        Country: requestParameters?.country,
        LegalEntity: requestParameters?.legalEntity,
        IsGlobal: requestParameters?.isGlobal,
        SearchQuery: requestParameters?.searchQuery,
        Discriminator: requestParameters?.discriminator,
        IsAttributeUpload: requestParameters?.isAttributeUpload,
        HasValuesAssigned: requestParameters?.hasValuesAssigned,
        IncludeValues: requestParameters?.includeValues,
        VariableType: requestParameters?.variableType,
        TemplateVersionId: requestParameters?.templateVersionId,
        Module: requestParameters?.module,
        EffectiveDate: requestParameters?.effectiveDate
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryCustomerGetValuesByIdAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerGetValuesByIdAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public employmentConditionLibraryCustomerGetValuesByIdAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerGetValuesByIdAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public employmentConditionLibraryCustomerGetValuesByIdAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerGetValuesByIdAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public employmentConditionLibraryCustomerGetValuesByIdAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerGetValuesByIdAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('employmentConditionLibraryCustomerGetValuesByIdAttributes', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/attributes/values/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        Name: requestParameters?.name,
        Country: requestParameters?.country,
        LegalEntity: requestParameters?.legalEntity,
        IsGlobal: requestParameters?.isGlobal,
        SearchQuery: requestParameters?.searchQuery,
        Discriminator: requestParameters?.discriminator,
        IsAttributeUpload: requestParameters?.isAttributeUpload,
        HasValuesAssigned: requestParameters?.hasValuesAssigned,
        IncludeValues: requestParameters?.includeValues,
        VariableType: requestParameters?.variableType,
        TemplateVersionId: requestParameters?.templateVersionId,
        Module: requestParameters?.module,
        EffectiveDate: requestParameters?.effectiveDate
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryCustomerQueryAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerQueryAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfAttributeLight>;
  public employmentConditionLibraryCustomerQueryAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerQueryAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfAttributeLight>>;
  public employmentConditionLibraryCustomerQueryAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerQueryAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfAttributeLight>>;
  public employmentConditionLibraryCustomerQueryAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerQueryAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/attributes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Name': requestParameters?.queryName,
        'Query.Country': requestParameters?.queryCountry,
        'Query.LegalEntity': requestParameters?.queryLegalEntity,
        'Query.IsGlobal': requestParameters?.queryIsGlobal,
        'Query.SearchQuery': requestParameters?.querySearchQuery,
        'Query.Discriminator': requestParameters?.queryDiscriminator,
        'Query.IsAttributeUpload': requestParameters?.queryIsAttributeUpload,
        'Query.HasValuesAssigned': requestParameters?.queryHasValuesAssigned,
        'Query.IncludeValues': requestParameters?.queryIncludeValues,
        'Query.VariableType': requestParameters?.queryVariableType,
        'Query.TemplateVersionId': requestParameters?.queryTemplateVersionId,
        'Query.Module': requestParameters?.queryModule,
        'Query.EffectiveDate': requestParameters?.queryEffectiveDate,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sortable.OrderBy': requestParameters?.sortableOrderBy,
        'Sortable.Property': requestParameters?.sortableProperty,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryCustomerQueryByGidsEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQueryByGidsEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEclEmployee>;
  public employmentConditionLibraryCustomerQueryByGidsEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQueryByGidsEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEclEmployee>>;
  public employmentConditionLibraryCustomerQueryByGidsEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQueryByGidsEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEclEmployee>>;
  public employmentConditionLibraryCustomerQueryByGidsEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQueryByGidsEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const country = requestParameters?.country;
    const legalEntity = requestParameters?.legalEntity;
    this.checkRequired('employmentConditionLibraryCustomerQueryByGidsEmployees', { country, legalEntity });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/employees/gids`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Country: country,
        LegalEntity: legalEntity,
        Gids: requestParameters?.gids,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sortable.OrderBy': requestParameters?.sortableOrderBy,
        'Sortable.Property': requestParameters?.sortableProperty,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryCustomerQueryClauseCategories(
    requestParameters?: EmploymentConditionLibraryCustomerQueryClauseCategoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public employmentConditionLibraryCustomerQueryClauseCategories(
    requestParameters?: EmploymentConditionLibraryCustomerQueryClauseCategoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public employmentConditionLibraryCustomerQueryClauseCategories(
    requestParameters?: EmploymentConditionLibraryCustomerQueryClauseCategoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public employmentConditionLibraryCustomerQueryClauseCategories(
    requestParameters?: EmploymentConditionLibraryCustomerQueryClauseCategoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const type = requestParameters?.type;
    this.checkRequired('employmentConditionLibraryCustomerQueryClauseCategories', { type });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/clause-categories`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Type: type,
        SearchQuery: requestParameters?.searchQuery,
        Cluster: requestParameters?.cluster,
        Subject: requestParameters?.subject,
        Topic: requestParameters?.topic,
        'Query.Countries': requestParameters?.queryCountries,
        'Query.LegalEntities': requestParameters?.queryLegalEntities,
        'Query.Clusters': requestParameters?.queryClusters,
        'Query.Subjects': requestParameters?.querySubjects,
        'Query.Topics': requestParameters?.queryTopics,
        'Query.Names': requestParameters?.queryNames,
        'Query.ClauseGroups': requestParameters?.queryClauseGroups,
        'Query.Search': requestParameters?.querySearch,
        'Query.ClauseStatus': requestParameters?.queryClauseStatus,
        'Query.EffectiveTo': requestParameters?.queryEffectiveTo,
        'Query.WithContent': requestParameters?.queryWithContent,
        'Query.LocalLanguage': requestParameters?.queryLocalLanguage,
        'Query.EffectiveFrom': requestParameters?.queryEffectiveFrom,
        'Query.IsQueryingForTemplate': requestParameters?.queryIsQueryingForTemplate,
        'Query.EffectiveDate': requestParameters?.queryEffectiveDate,
        'CategoryQuery.Cluster.Values': requestParameters?.categoryQueryClusterValues,
        'CategoryQuery.Cluster.Type': requestParameters?.categoryQueryClusterType,
        'CategoryQuery.Subject.Values': requestParameters?.categoryQuerySubjectValues,
        'CategoryQuery.Subject.Type': requestParameters?.categoryQuerySubjectType,
        'CategoryQuery.Topic.Values': requestParameters?.categoryQueryTopicValues,
        'CategoryQuery.Topic.Type': requestParameters?.categoryQueryTopicType,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        ParentId: requestParameters?.parentId,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryCustomerQueryEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQueryEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEclEmployee>;
  public employmentConditionLibraryCustomerQueryEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQueryEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEclEmployee>>;
  public employmentConditionLibraryCustomerQueryEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQueryEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEclEmployee>>;
  public employmentConditionLibraryCustomerQueryEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQueryEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        IncludeManagerInformation: requestParameters?.includeManagerInformation,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.Country': requestParameters?.queryCountry,
        'Query.LegalEntity': requestParameters?.queryLegalEntity,
        'Query.DataSource': requestParameters?.queryDataSource,
        'Query.Module': requestParameters?.queryModule,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        Module: requestParameters?.module,
        EffectiveDate: requestParameters?.effectiveDate
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryCustomerQueryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQueryFieldValueEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public employmentConditionLibraryCustomerQueryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQueryFieldValueEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public employmentConditionLibraryCustomerQueryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQueryFieldValueEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public employmentConditionLibraryCustomerQueryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQueryFieldValueEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const fieldName = requestParameters?.fieldName;
    this.checkRequired('employmentConditionLibraryCustomerQueryFieldValueEmployees', { fieldName });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/employees/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        Gid: requestParameters?.gid,
        FullName: requestParameters?.fullName,
        Country: requestParameters?.country,
        LegalEntity: requestParameters?.legalEntity,
        DataSource: requestParameters?.dataSource,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryCustomerQueryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerQueryFieldValuesAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public employmentConditionLibraryCustomerQueryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerQueryFieldValuesAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public employmentConditionLibraryCustomerQueryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerQueryFieldValuesAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public employmentConditionLibraryCustomerQueryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerQueryFieldValuesAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const fieldName = requestParameters?.fieldName;
    this.checkRequired('employmentConditionLibraryCustomerQueryFieldValuesAttributes', { fieldName });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/attributes/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Name: requestParameters?.name,
        Country: requestParameters?.country,
        LegalEntity: requestParameters?.legalEntity,
        IsGlobal: requestParameters?.isGlobal,
        SearchQuery: requestParameters?.searchQuery,
        Discriminator: requestParameters?.discriminator,
        IsAttributeUpload: requestParameters?.isAttributeUpload,
        HasValuesAssigned: requestParameters?.hasValuesAssigned,
        IncludeValues: requestParameters?.includeValues,
        VariableType: requestParameters?.variableType,
        TemplateVersionId: requestParameters?.templateVersionId,
        Module: requestParameters?.module,
        EffectiveDate: requestParameters?.effectiveDate,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryCustomerQuerySimulatedEmployeesEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQuerySimulatedEmployeesEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEclEmployee>;
  public employmentConditionLibraryCustomerQuerySimulatedEmployeesEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQuerySimulatedEmployeesEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEclEmployee>>;
  public employmentConditionLibraryCustomerQuerySimulatedEmployeesEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQuerySimulatedEmployeesEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEclEmployee>>;
  public employmentConditionLibraryCustomerQuerySimulatedEmployeesEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerQuerySimulatedEmployeesEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/condition-library/customer/v1/employees/simulate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.querySimulatedEmployees,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryCustomerQueryUsers(
    requestParameters?: EmploymentConditionLibraryCustomerQueryUsersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmploymentConditionLibraryUsersUser>;
  public employmentConditionLibraryCustomerQueryUsers(
    requestParameters?: EmploymentConditionLibraryCustomerQueryUsersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmploymentConditionLibraryUsersUser>>;
  public employmentConditionLibraryCustomerQueryUsers(
    requestParameters?: EmploymentConditionLibraryCustomerQueryUsersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmploymentConditionLibraryUsersUser>>;
  public employmentConditionLibraryCustomerQueryUsers(
    requestParameters?: EmploymentConditionLibraryCustomerQueryUsersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/users`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        Middlename: requestParameters?.middlename,
        Gid: requestParameters?.gid,
        IsApproverAuthorized: requestParameters?.isApproverAuthorized,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportClauses(
    requestParameters?: ExportClausesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BaseRedisEntity>;
  public exportClauses(
    requestParameters?: ExportClausesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BaseRedisEntity>>;
  public exportClauses(
    requestParameters?: ExportClausesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BaseRedisEntity>>;
  public exportClauses(requestParameters?: ExportClausesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/clauses/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.exportClauses,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportContractAssignment(
    requestParameters?: ExportContractAssignmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportContractAssignment(
    requestParameters?: ExportContractAssignmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportContractAssignment(
    requestParameters?: ExportContractAssignmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportContractAssignment(
    requestParameters?: ExportContractAssignmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/contract-assignments/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.exportContractAssignments,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportFilteredActivityStreamClauseActivityStream(
    requestParameters?: ExportFilteredActivityStreamClauseActivityStreamParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportFilteredActivityStreamClauseActivityStream(
    requestParameters?: ExportFilteredActivityStreamClauseActivityStreamParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportFilteredActivityStreamClauseActivityStream(
    requestParameters?: ExportFilteredActivityStreamClauseActivityStreamParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportFilteredActivityStreamClauseActivityStream(
    requestParameters?: ExportFilteredActivityStreamClauseActivityStreamParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/clauses/activity-stream/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.exportClauseActivities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportFilteredActivityStreamTemplateActivityStream(
    requestParameters?: ExportFilteredActivityStreamTemplateActivityStreamParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportFilteredActivityStreamTemplateActivityStream(
    requestParameters?: ExportFilteredActivityStreamTemplateActivityStreamParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportFilteredActivityStreamTemplateActivityStream(
    requestParameters?: ExportFilteredActivityStreamTemplateActivityStreamParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportFilteredActivityStreamTemplateActivityStream(
    requestParameters?: ExportFilteredActivityStreamTemplateActivityStreamParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/templates/activity-stream/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.exportTemplateActivitiesParameter,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportTemplateAssociationsClauses(
    requestParameters?: ExportTemplateAssociationsClausesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportTemplateAssociationsClauses(
    requestParameters?: ExportTemplateAssociationsClausesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportTemplateAssociationsClauses(
    requestParameters?: ExportTemplateAssociationsClausesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportTemplateAssociationsClauses(
    requestParameters?: ExportTemplateAssociationsClausesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/clauses/export/template-associations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.exportClauseTemplateAssociations,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportTemplates(
    requestParameters?: ExportTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BaseRedisEntity>;
  public exportTemplates(
    requestParameters?: ExportTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BaseRedisEntity>>;
  public exportTemplates(
    requestParameters?: ExportTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BaseRedisEntity>>;
  public exportTemplates(requestParameters?: ExportTemplatesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/templates/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.createTemplateExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public generateContractActionContentDocumentGeneration(
    requestParameters?: GenerateContractActionContentDocumentGenerationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<FilledTemplateContentResponse>;
  public generateContractActionContentDocumentGeneration(
    requestParameters?: GenerateContractActionContentDocumentGenerationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<FilledTemplateContentResponse>>;
  public generateContractActionContentDocumentGeneration(
    requestParameters?: GenerateContractActionContentDocumentGenerationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<FilledTemplateContentResponse>>;
  public generateContractActionContentDocumentGeneration(
    requestParameters?: GenerateContractActionContentDocumentGenerationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const actionId = requestParameters?.actionId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('generateContractActionContentDocumentGeneration', { actionId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/document-generation/contract-actions/${this.configuration.encodeParam({ name: 'actionId', value: actionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/generate-content`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getActivityStreamForVersionClauseVersions(
    requestParameters?: GetActivityStreamForVersionClauseVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfActivityStreamOfString>;
  public getActivityStreamForVersionClauseVersions(
    requestParameters?: GetActivityStreamForVersionClauseVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfActivityStreamOfString>>;
  public getActivityStreamForVersionClauseVersions(
    requestParameters?: GetActivityStreamForVersionClauseVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfActivityStreamOfString>>;
  public getActivityStreamForVersionClauseVersions(
    requestParameters?: GetActivityStreamForVersionClauseVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('getActivityStreamForVersionClauseVersions', { clauseId, versionId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/activity-stream`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size, module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAttributesTemplateVersionSimulation(
    requestParameters?: GetAttributesTemplateVersionSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<AttributeAssignments>;
  public getAttributesTemplateVersionSimulation(
    requestParameters?: GetAttributesTemplateVersionSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<AttributeAssignments>>;
  public getAttributesTemplateVersionSimulation(
    requestParameters?: GetAttributesTemplateVersionSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<AttributeAssignments>>;
  public getAttributesTemplateVersionSimulation(
    requestParameters?: GetAttributesTemplateVersionSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const versionId = requestParameters?.versionId;
    const templateId = requestParameters?.templateId;
    this.checkRequired('getAttributesTemplateVersionSimulation', { versionId, templateId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulation/attributes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCachedContentDocumentGeneration(
    requestParameters?: GetCachedContentDocumentGenerationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public getCachedContentDocumentGeneration(
    requestParameters?: GetCachedContentDocumentGenerationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public getCachedContentDocumentGeneration(
    requestParameters?: GetCachedContentDocumentGenerationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public getCachedContentDocumentGeneration(
    requestParameters?: GetCachedContentDocumentGenerationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const actionId = requestParameters?.actionId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getCachedContentDocumentGeneration', { actionId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/document-generation/contract-actions/${this.configuration.encodeParam({ name: 'actionId', value: actionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: [],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getClauseDetailsClauses(
    requestParameters?: GetClauseDetailsClausesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClauseDetails>;
  public getClauseDetailsClauses(
    requestParameters?: GetClauseDetailsClausesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClauseDetails>>;
  public getClauseDetailsClauses(
    requestParameters?: GetClauseDetailsClausesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClauseDetails>>;
  public getClauseDetailsClauses(
    requestParameters?: GetClauseDetailsClausesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    this.checkRequired('getClauseDetailsClauses', { clauseId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getClauseVersionClauseVersions(
    requestParameters?: GetClauseVersionClauseVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClauseVersion>;
  public getClauseVersionClauseVersions(
    requestParameters?: GetClauseVersionClauseVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClauseVersion>>;
  public getClauseVersionClauseVersions(
    requestParameters?: GetClauseVersionClauseVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClauseVersion>>;
  public getClauseVersionClauseVersions(
    requestParameters?: GetClauseVersionClauseVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('getClauseVersionClauseVersions', { clauseId, versionId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getContractActions(
    requestParameters?: GetContractActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ContractActionDetails>;
  public getContractActions(
    requestParameters?: GetContractActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ContractActionDetails>>;
  public getContractActions(
    requestParameters?: GetContractActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ContractActionDetails>>;
  public getContractActions(requestParameters?: GetContractActionsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getContractActions', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/folders/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCountryAndAreCountsContractActions(
    requestParameters?: GetCountryAndAreCountsContractActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<DocumentGenerationFieldValueWithCounts>;
  public getCountryAndAreCountsContractActions(
    requestParameters?: GetCountryAndAreCountsContractActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<DocumentGenerationFieldValueWithCounts>>;
  public getCountryAndAreCountsContractActions(
    requestParameters?: GetCountryAndAreCountsContractActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<DocumentGenerationFieldValueWithCounts>>;
  public getCountryAndAreCountsContractActions(
    requestParameters?: GetCountryAndAreCountsContractActionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/folders/fields/count`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Countries: requestParameters?.countries,
        LegalEntities: requestParameters?.legalEntities,
        ContractActionStatus: requestParameters?.contractActionStatus,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getLatestClauseVersions(
    requestParameters?: GetLatestClauseVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClauseVersion>;
  public getLatestClauseVersions(
    requestParameters?: GetLatestClauseVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClauseVersion>>;
  public getLatestClauseVersions(
    requestParameters?: GetLatestClauseVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClauseVersion>>;
  public getLatestClauseVersions(
    requestParameters?: GetLatestClauseVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    this.checkRequired('getLatestClauseVersions', { clauseId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/latest`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getLatestTemplateVersions(
    requestParameters?: GetLatestTemplateVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TemplateVersion>;
  public getLatestTemplateVersions(
    requestParameters?: GetLatestTemplateVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TemplateVersion>>;
  public getLatestTemplateVersions(
    requestParameters?: GetLatestTemplateVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TemplateVersion>>;
  public getLatestTemplateVersions(
    requestParameters?: GetLatestTemplateVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    this.checkRequired('getLatestTemplateVersions', { templateId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/latest`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSimulatedContentTemplateVersionSimulation(
    requestParameters?: GetSimulatedContentTemplateVersionSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ConclusiveTransactionStatusOfTemplateSimulationMetadata>;
  public getSimulatedContentTemplateVersionSimulation(
    requestParameters?: GetSimulatedContentTemplateVersionSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ConclusiveTransactionStatusOfTemplateSimulationMetadata>>;
  public getSimulatedContentTemplateVersionSimulation(
    requestParameters?: GetSimulatedContentTemplateVersionSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ConclusiveTransactionStatusOfTemplateSimulationMetadata>>;
  public getSimulatedContentTemplateVersionSimulation(
    requestParameters?: GetSimulatedContentTemplateVersionSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const versionId = requestParameters?.versionId;
    const templateId = requestParameters?.templateId;
    this.checkRequired('getSimulatedContentTemplateVersionSimulation', { versionId, templateId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulation/content-status`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTemplateVersions(
    requestParameters?: GetTemplateVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TemplateVersion>;
  public getTemplateVersions(
    requestParameters?: GetTemplateVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TemplateVersion>>;
  public getTemplateVersions(
    requestParameters?: GetTemplateVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TemplateVersion>>;
  public getTemplateVersions(requestParameters?: GetTemplateVersionsParams, ...args: RequestArgs): Observable<any> {
    const templateId = requestParameters?.templateId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('getTemplateVersions', { templateId, versionId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTemplates(
    requestParameters?: GetTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TemplateDetails>;
  public getTemplates(
    requestParameters?: GetTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TemplateDetails>>;
  public getTemplates(
    requestParameters?: GetTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TemplateDetails>>;
  public getTemplates(requestParameters?: GetTemplatesParams, ...args: RequestArgs): Observable<any> {
    const templateId = requestParameters?.templateId;
    this.checkRequired('getTemplates', { templateId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public publishDocumentsContractActions(
    requestParameters?: PublishDocumentsContractActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public publishDocumentsContractActions(
    requestParameters?: PublishDocumentsContractActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public publishDocumentsContractActions(
    requestParameters?: PublishDocumentsContractActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public publishDocumentsContractActions(
    requestParameters?: PublishDocumentsContractActionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('publishDocumentsContractActions', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/folders/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.publishDocuments,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryActivityStreamTemplateVersions(
    requestParameters?: QueryActivityStreamTemplateVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfActivityStreamOfString>;
  public queryActivityStreamTemplateVersions(
    requestParameters?: QueryActivityStreamTemplateVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfActivityStreamOfString>>;
  public queryActivityStreamTemplateVersions(
    requestParameters?: QueryActivityStreamTemplateVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfActivityStreamOfString>>;
  public queryActivityStreamTemplateVersions(
    requestParameters?: QueryActivityStreamTemplateVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('queryActivityStreamTemplateVersions', { templateId, versionId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/activity-stream`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size, module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryByTemplateEmployees(
    requestParameters?: QueryByTemplateEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEclEmployee>;
  public queryByTemplateEmployees(
    requestParameters?: QueryByTemplateEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEclEmployee>>;
  public queryByTemplateEmployees(
    requestParameters?: QueryByTemplateEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEclEmployee>>;
  public queryByTemplateEmployees(
    requestParameters?: QueryByTemplateEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    this.checkRequired('queryByTemplateEmployees', { templateId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/employees/template`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TemplateId: templateId,
        EffectiveDate: requestParameters?.effectiveDate,
        SearchString: requestParameters?.searchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryClauses(
    requestParameters?: QueryClausesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfClauseDetailsLight>;
  public queryClauses(
    requestParameters?: QueryClausesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfClauseDetailsLight>>;
  public queryClauses(
    requestParameters?: QueryClausesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfClauseDetailsLight>>;
  public queryClauses(requestParameters?: QueryClausesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/clauses`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Countries: requestParameters?.countries,
        LegalEntities: requestParameters?.legalEntities,
        Clusters: requestParameters?.clusters,
        Subjects: requestParameters?.subjects,
        Topics: requestParameters?.topics,
        Names: requestParameters?.names,
        ClauseGroups: requestParameters?.clauseGroups,
        Search: requestParameters?.search,
        ClauseStatus: requestParameters?.clauseStatus,
        EffectiveTo: requestParameters?.effectiveTo,
        WithContent: requestParameters?.withContent,
        LocalLanguage: requestParameters?.localLanguage,
        EffectiveFrom: requestParameters?.effectiveFrom,
        IsQueryingForTemplate: requestParameters?.isQueryingForTemplate,
        EffectiveDate: requestParameters?.effectiveDate,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryContractActions(
    requestParameters?: QueryContractActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfContractActionLight>;
  public queryContractActions(
    requestParameters?: QueryContractActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfContractActionLight>>;
  public queryContractActions(
    requestParameters?: QueryContractActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfContractActionLight>>;
  public queryContractActions(requestParameters?: QueryContractActionsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/folders`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.LegalEntities': requestParameters?.queryLegalEntities,
        'Query.Countries': requestParameters?.queryCountries,
        'Query.DocumentType': requestParameters?.queryDocumentType,
        'Query.Search': requestParameters?.querySearch,
        'Query.ContractActionStatus': requestParameters?.queryContractActionStatus,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sortable.OrderBy': requestParameters?.sortableOrderBy,
        'Sortable.Property': requestParameters?.sortableProperty,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryContractAssignmentsContractActions(
    requestParameters?: QueryContractAssignmentsContractActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfContractAssignmentLight>;
  public queryContractAssignmentsContractActions(
    requestParameters?: QueryContractAssignmentsContractActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfContractAssignmentLight>>;
  public queryContractAssignmentsContractActions(
    requestParameters?: QueryContractAssignmentsContractActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfContractAssignmentLight>>;
  public queryContractAssignmentsContractActions(
    requestParameters?: QueryContractAssignmentsContractActionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('queryContractAssignmentsContractActions', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/folders/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/assignments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Status': requestParameters?.queryStatus,
        'Query.SearchQuery': requestParameters?.querySearchQuery,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sortable.OrderBy': requestParameters?.sortableOrderBy,
        'Sortable.Property': requestParameters?.sortableProperty,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValueWithCountsClauses(
    requestParameters?: QueryFieldValueWithCountsClausesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClauseFieldValueWithCounts>;
  public queryFieldValueWithCountsClauses(
    requestParameters?: QueryFieldValueWithCountsClausesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClauseFieldValueWithCounts>>;
  public queryFieldValueWithCountsClauses(
    requestParameters?: QueryFieldValueWithCountsClausesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClauseFieldValueWithCounts>>;
  public queryFieldValueWithCountsClauses(
    requestParameters?: QueryFieldValueWithCountsClausesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/clauses/fields/count`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.Countries': requestParameters?.queryCountries,
        'Query.LegalEntities': requestParameters?.queryLegalEntities,
        'Query.Clusters': requestParameters?.queryClusters,
        'Query.Subjects': requestParameters?.querySubjects,
        'Query.Topics': requestParameters?.queryTopics,
        'Query.Names': requestParameters?.queryNames,
        'Query.ClauseGroups': requestParameters?.queryClauseGroups,
        'Query.Search': requestParameters?.querySearch,
        'Query.ClauseStatus': requestParameters?.queryClauseStatus,
        'Query.EffectiveTo': requestParameters?.queryEffectiveTo,
        'Query.WithContent': requestParameters?.queryWithContent,
        'Query.LocalLanguage': requestParameters?.queryLocalLanguage,
        'Query.EffectiveFrom': requestParameters?.queryEffectiveFrom,
        'Query.IsQueryingForTemplate': requestParameters?.queryIsQueryingForTemplate,
        'Query.EffectiveDate': requestParameters?.queryEffectiveDate,
        Country: requestParameters?.country,
        LegalEntity: requestParameters?.legalEntity,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesContractActions(
    requestParameters?: QueryFieldValuesContractActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesContractActions(
    requestParameters?: QueryFieldValuesContractActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesContractActions(
    requestParameters?: QueryFieldValuesContractActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesContractActions(
    requestParameters?: QueryFieldValuesContractActionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/folders/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'PageableRequest.Page': requestParameters?.pageableRequestPage,
        'PageableRequest.Size': requestParameters?.pageableRequestSize,
        TargetProperty: requestParameters?.targetProperty,
        LegalEntities: requestParameters?.legalEntities,
        Countries: requestParameters?.countries,
        DocumentType: requestParameters?.documentType,
        Search: requestParameters?.search,
        ContractActionStatus: requestParameters?.contractActionStatus
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesForClauseCreationClauses(
    requestParameters?: QueryFieldValuesForClauseCreationClausesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<FieldValues>;
  public queryFieldValuesForClauseCreationClauses(
    requestParameters?: QueryFieldValuesForClauseCreationClausesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<FieldValues>>;
  public queryFieldValuesForClauseCreationClauses(
    requestParameters?: QueryFieldValuesForClauseCreationClausesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<FieldValues>>;
  public queryFieldValuesForClauseCreationClauses(
    requestParameters?: QueryFieldValuesForClauseCreationClausesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/clauses/fields`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.Countries': requestParameters?.queryCountries,
        'Query.LegalEntities': requestParameters?.queryLegalEntities,
        'Query.Clusters': requestParameters?.queryClusters,
        'Query.Subjects': requestParameters?.querySubjects,
        'Query.Topics': requestParameters?.queryTopics,
        'Query.Names': requestParameters?.queryNames,
        'Query.ClauseGroups': requestParameters?.queryClauseGroups,
        'Query.Search': requestParameters?.querySearch,
        'Query.ClauseStatus': requestParameters?.queryClauseStatus,
        'Query.EffectiveTo': requestParameters?.queryEffectiveTo,
        'Query.WithContent': requestParameters?.queryWithContent,
        'Query.LocalLanguage': requestParameters?.queryLocalLanguage,
        'Query.EffectiveFrom': requestParameters?.queryEffectiveFrom,
        'Query.IsQueryingForTemplate': requestParameters?.queryIsQueryingForTemplate,
        'Query.EffectiveDate': requestParameters?.queryEffectiveDate,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesTemplates(
    requestParameters?: QueryFieldValuesTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TemplateFieldValueWithCounts>;
  public queryFieldValuesTemplates(
    requestParameters?: QueryFieldValuesTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TemplateFieldValueWithCounts>>;
  public queryFieldValuesTemplates(
    requestParameters?: QueryFieldValuesTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TemplateFieldValueWithCounts>>;
  public queryFieldValuesTemplates(
    requestParameters?: QueryFieldValuesTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/templates/fields/count`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Countries: requestParameters?.countries,
        LegalEntities: requestParameters?.legalEntities,
        IsQueryingForDocumentGeneration: requestParameters?.isQueryingForDocumentGeneration,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFilteredActivityStreamClauseActivityStream(
    requestParameters?: QueryFilteredActivityStreamClauseActivityStreamParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfActivityStreamOfString>;
  public queryFilteredActivityStreamClauseActivityStream(
    requestParameters?: QueryFilteredActivityStreamClauseActivityStreamParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfActivityStreamOfString>>;
  public queryFilteredActivityStreamClauseActivityStream(
    requestParameters?: QueryFilteredActivityStreamClauseActivityStreamParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfActivityStreamOfString>>;
  public queryFilteredActivityStreamClauseActivityStream(
    requestParameters?: QueryFilteredActivityStreamClauseActivityStreamParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/clauses/activity-stream/filtered`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        Name: requestParameters?.name,
        UserSearch: requestParameters?.userSearch,
        EventOperation: requestParameters?.eventOperation,
        FromDate: requestParameters?.fromDate,
        ToDate: requestParameters?.toDate,
        ChangedProperty: requestParameters?.changedProperty,
        MetadataItem: requestParameters?.metadataItem,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        EventTypes: requestParameters?.eventTypes,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFilteredActivityStreamTemplateActivityStream(
    requestParameters?: QueryFilteredActivityStreamTemplateActivityStreamParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfActivityStreamOfString>;
  public queryFilteredActivityStreamTemplateActivityStream(
    requestParameters?: QueryFilteredActivityStreamTemplateActivityStreamParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfActivityStreamOfString>>;
  public queryFilteredActivityStreamTemplateActivityStream(
    requestParameters?: QueryFilteredActivityStreamTemplateActivityStreamParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfActivityStreamOfString>>;
  public queryFilteredActivityStreamTemplateActivityStream(
    requestParameters?: QueryFilteredActivityStreamTemplateActivityStreamParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/templates/activity-stream/filtered`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        Name: requestParameters?.name,
        UserSearch: requestParameters?.userSearch,
        EventOperation: requestParameters?.eventOperation,
        FromDate: requestParameters?.fromDate,
        ToDate: requestParameters?.toDate,
        ChangedProperty: requestParameters?.changedProperty,
        MetadataItem: requestParameters?.metadataItem,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        EventTypes: requestParameters?.eventTypes,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySignatureAuthorization(
    requestParameters?: QuerySignatureAuthorizationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSignerEmployee>;
  public querySignatureAuthorization(
    requestParameters?: QuerySignatureAuthorizationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSignerEmployee>>;
  public querySignatureAuthorization(
    requestParameters?: QuerySignatureAuthorizationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSignerEmployee>>;
  public querySignatureAuthorization(
    requestParameters?: QuerySignatureAuthorizationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const legalEntity = requestParameters?.legalEntity;
    this.checkRequired('querySignatureAuthorization', { legalEntity });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/signature-authorizations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        LegalEntity: legalEntity,
        SearchQuery: requestParameters?.searchQuery,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTemplates(
    requestParameters?: QueryTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTemplateDetailsLight>;
  public queryTemplates(
    requestParameters?: QueryTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTemplateDetailsLight>>;
  public queryTemplates(
    requestParameters?: QueryTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTemplateDetailsLight>>;
  public queryTemplates(requestParameters?: QueryTemplatesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/customer/v1/templates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Countries': requestParameters?.queryCountries,
        'Query.LegalEntities': requestParameters?.queryLegalEntities,
        'Query.TemplateType': requestParameters?.queryTemplateType,
        'Query.ClauseIds': requestParameters?.queryClauseIds,
        'Query.Search': requestParameters?.querySearch,
        'Query.TemplateStatus': requestParameters?.queryTemplateStatus,
        'Query.IsQueryingForDocumentGeneration': requestParameters?.queryIsQueryingForDocumentGeneration,
        'Query.Approver': requestParameters?.queryApprover,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sortable.OrderBy': requestParameters?.sortableOrderBy,
        'Sortable.Property': requestParameters?.sortableProperty,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recomputeAllTemplateAttributesTemplates(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfRecomputeTemplateAttributesMetadata>;
  public recomputeAllTemplateAttributesTemplates(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfRecomputeTemplateAttributesMetadata>>;
  public recomputeAllTemplateAttributesTemplates(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfRecomputeTemplateAttributesMetadata>>;
  public recomputeAllTemplateAttributesTemplates(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/templates/recompute-attributes`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rejectClauseVersions(
    requestParameters?: RejectClauseVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public rejectClauseVersions(
    requestParameters?: RejectClauseVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public rejectClauseVersions(
    requestParameters?: RejectClauseVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public rejectClauseVersions(requestParameters?: RejectClauseVersionsParams, ...args: RequestArgs): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('rejectClauseVersions', { clauseId, versionId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/reject`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.rejectClauseVersion,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rejectTemplateVersions(
    requestParameters?: RejectTemplateVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public rejectTemplateVersions(
    requestParameters?: RejectTemplateVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public rejectTemplateVersions(
    requestParameters?: RejectTemplateVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public rejectTemplateVersions(
    requestParameters?: RejectTemplateVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    const id = requestParameters?.id;
    this.checkRequired('rejectTemplateVersions', { templateId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/reject`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.rejectTemplateVersion,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public retireClauseClauses(
    requestParameters?: RetireClauseClausesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClauseDetails>;
  public retireClauseClauses(
    requestParameters?: RetireClauseClausesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClauseDetails>>;
  public retireClauseClauses(
    requestParameters?: RetireClauseClausesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClauseDetails>>;
  public retireClauseClauses(requestParameters?: RetireClauseClausesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('retireClauseClauses', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/retire`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.retireClause,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public retireTemplates(
    requestParameters?: RetireTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TemplateDetails>;
  public retireTemplates(
    requestParameters?: RetireTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TemplateDetails>>;
  public retireTemplates(
    requestParameters?: RetireTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TemplateDetails>>;
  public retireTemplates(requestParameters?: RetireTemplatesParams, ...args: RequestArgs): Observable<any> {
    const templateId = requestParameters?.templateId;
    this.checkRequired('retireTemplates', { templateId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/retire`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.retireTemplate,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public sendToApproverClauseVersions(
    requestParameters?: SendToApproverClauseVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public sendToApproverClauseVersions(
    requestParameters?: SendToApproverClauseVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public sendToApproverClauseVersions(
    requestParameters?: SendToApproverClauseVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public sendToApproverClauseVersions(
    requestParameters?: SendToApproverClauseVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('sendToApproverClauseVersions', { clauseId, versionId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/send-to-approver`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.sendToApprover,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public sendToApproverTemplateVersions(
    requestParameters?: SendToApproverTemplateVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public sendToApproverTemplateVersions(
    requestParameters?: SendToApproverTemplateVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public sendToApproverTemplateVersions(
    requestParameters?: SendToApproverTemplateVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public sendToApproverTemplateVersions(
    requestParameters?: SendToApproverTemplateVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('sendToApproverTemplateVersions', { templateId, versionId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/send-to-approver`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.sendToApprover,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateContentTemplateVersionSimulation(
    requestParameters?: SimulateContentTemplateVersionSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ConclusiveTransactionStatusOfTemplateSimulationMetadata>;
  public simulateContentTemplateVersionSimulation(
    requestParameters?: SimulateContentTemplateVersionSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ConclusiveTransactionStatusOfTemplateSimulationMetadata>>;
  public simulateContentTemplateVersionSimulation(
    requestParameters?: SimulateContentTemplateVersionSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ConclusiveTransactionStatusOfTemplateSimulationMetadata>>;
  public simulateContentTemplateVersionSimulation(
    requestParameters?: SimulateContentTemplateVersionSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const versionId = requestParameters?.versionId;
    const templateId = requestParameters?.templateId;
    this.checkRequired('simulateContentTemplateVersionSimulation', { versionId, templateId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulation/simulate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.simulateTemplateContent,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public transferClauseClauses(
    requestParameters?: TransferClauseClausesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public transferClauseClauses(
    requestParameters?: TransferClauseClausesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public transferClauseClauses(
    requestParameters?: TransferClauseClausesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public transferClauseClauses(requestParameters?: TransferClauseClausesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('transferClauseClauses', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/transfer`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.transferEmploymentConditionsLibraryEntity,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public transferTemplateTemplates(
    requestParameters?: TransferTemplateTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public transferTemplateTemplates(
    requestParameters?: TransferTemplateTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public transferTemplateTemplates(
    requestParameters?: TransferTemplateTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public transferTemplateTemplates(
    requestParameters?: TransferTemplateTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('transferTemplateTemplates', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/transfer`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.transferEmploymentConditionsLibraryEntity,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateClauseVersions(
    requestParameters?: UpdateClauseVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClauseVersion>;
  public updateClauseVersions(
    requestParameters?: UpdateClauseVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClauseVersion>>;
  public updateClauseVersions(
    requestParameters?: UpdateClauseVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClauseVersion>>;
  public updateClauseVersions(requestParameters?: UpdateClauseVersionsParams, ...args: RequestArgs): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('updateClauseVersions', { clauseId, versionId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.updateClauseVersion,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateContentTemplateVersions(
    requestParameters?: UpdateContentTemplateVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TemplateVersion>;
  public updateContentTemplateVersions(
    requestParameters?: UpdateContentTemplateVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TemplateVersion>>;
  public updateContentTemplateVersions(
    requestParameters?: UpdateContentTemplateVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TemplateVersion>>;
  public updateContentTemplateVersions(
    requestParameters?: UpdateContentTemplateVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('updateContentTemplateVersions', { templateId, versionId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.updateTemplateVersionContent,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateTemplateRuleSetTemplates(
    requestParameters?: UpdateTemplateRuleSetTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TemplateDetails>;
  public updateTemplateRuleSetTemplates(
    requestParameters?: UpdateTemplateRuleSetTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TemplateDetails>>;
  public updateTemplateRuleSetTemplates(
    requestParameters?: UpdateTemplateRuleSetTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TemplateDetails>>;
  public updateTemplateRuleSetTemplates(
    requestParameters?: UpdateTemplateRuleSetTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    this.checkRequired('updateTemplateRuleSetTemplates', { templateId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/rule-set`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.updateTemplateRuleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateTemplateVersions(
    requestParameters?: UpdateTemplateVersionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TemplateVersion>;
  public updateTemplateVersions(
    requestParameters?: UpdateTemplateVersionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TemplateVersion>>;
  public updateTemplateVersions(
    requestParameters?: UpdateTemplateVersionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TemplateVersion>>;
  public updateTemplateVersions(
    requestParameters?: UpdateTemplateVersionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    const versionId = requestParameters?.versionId;
    this.checkRequired('updateTemplateVersions', { templateId, versionId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.updateTemplateVersion,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validateDocumentGeneration(
    requestParameters?: ValidateDocumentGenerationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<MatchedTemplate>>;
  public validateDocumentGeneration(
    requestParameters?: ValidateDocumentGenerationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<MatchedTemplate>>>;
  public validateDocumentGeneration(
    requestParameters?: ValidateDocumentGenerationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<MatchedTemplate>>>;
  public validateDocumentGeneration(
    requestParameters?: ValidateDocumentGenerationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/customer/v1/document-generation/validation`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.documentGenerationValidationRequest,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
